module.exports = __webpack_public_path__ + "img/type_32-b-150_7.prt.43873d23.jpg";